export class ContentAccessibilityPopup {
  popupTitle: string;
  popupDesc: string;
  primaryLabel: string;
  secondaryLabel: string;
  popupQuestion: string;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['popupTitle']) {
        this.popupTitle = contentjson['popupTitle'];
      }
      if (contentjson['popupDesc']) {
        this.popupDesc = contentjson['popupDesc'];
      }
      if (contentjson['primaryLabel']) {
        this.primaryLabel = contentjson['primaryLabel'];
      }
      if (contentjson['secondaryLabel']) {
        this.secondaryLabel = contentjson['secondaryLabel'];
      }
      if (contentjson['popupQuestion']) {
        this.popupQuestion = contentjson['popupQuestion'];
      }
    }
  }
}
